// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as PopularProductsActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import PopularProducts from '../components/PopularProducts';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    localValues: state.localValues,
    localeState: state.locale,
    pageCanAsk: state.popularProducts.pageCanAsk,
    page: state.popularProducts.page,
    isFetchingProducts: state.popularProducts.isFetchingProducts,
    fetchProductsError: state.popularProducts.fetchProductsError,
    products: state.popularProducts.products,
    chosenVariants: state.abTest.chosenVariants,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...PopularProductsActions,
    ...AlertActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PopularProducts);



// WEBPACK FOOTER //
// ./src/modules/popular-products/container/PopularProductsContainer.js